// frontend/src/theme/components/badge.js
// getColorSchemeContrast kaldırıldı
import { mode, transparentize } from '@chakra-ui/theme-tools';

const Badge = {
  baseStyle: {
    px: 2.5,
    py: 1,
    borderRadius: 'md',
    fontWeight: 'semibold',
    fontSize: 'xs',
    textTransform: 'none',
    lineHeight: 'short',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    whiteSpace: 'nowrap',
    transitionProperty: 'common',
    transitionDuration: 'var(--motion-duration-fast)',
    transitionTimingFunction: 'var(--motion-ease-apple)',
  },
  variants: {
    // Dolgulu (Solid) Varyant
    solid: (props) => {
      const { colorScheme: c } = props; // theme kaldırıldı

      // Koyu mod için arkaplan rengi
      const darkBg = `${c}.300`; // Koyu modda rengin 300 tonu

      // Açık mod metin rengi: Genellikle beyaz, sarı/cyan/gri için koyu
      const lightColor = ['yellow', 'cyan', 'gray'].includes(c) ? 'gray.800' : 'white';
      // Koyu mod metin rengi: Genellikle koyu gri/siyah (.300 tonu için)
      // Gri renk şeması koyu modda farklı olabilir
      const darkColor = c === 'gray' ? 'whiteAlpha.900' : 'gray.800';

      return {
        bg: mode(`${c}.500`, darkBg)(props), // Arkaplan rengi
        color: mode(lightColor, darkColor)(props), // mode ile belirlenen metin rengi
      };
    },
    // Hafif Arkaplanlı (Subtle) Varyant
    subtle: (props) => {
      const { colorScheme: c, theme } = props; // transparentize için theme gerekli
      const darkSubtleBg = transparentize(`${c}.200`, 0.16)(theme);
      return {
        bg: mode(`${c}.100`, darkSubtleBg)(props),
        color: mode(`${c}.700`, `${c}.200`)(props),
      };
    },
    // Dış Çizgili (Outline) Varyant
    outline: (props) => {
      const { colorScheme: c } = props;
      const color = mode(`${c}.600`, `${c}.200`)(props); // Metin rengini al
      return {
        color: color, // Metin rengini ayarla
        // Gölge ile kenarlık efekti, metin rengini kullanır
        boxShadow: `inset 0 0 0px 1px ${color}`,
      };
    },
    // Pill (Hap) Varyantı
    pill: (props) => {
        const { colorScheme: c, theme } = props; // transparentize için theme gerekli
        const darkPillBg = transparentize(`${c}.300`, 0.2)(theme);
        return {
            borderRadius: 'full',
            px: 3,
            py: 1,
            fontSize: 'xs',
            fontWeight: 'medium',
            bg: mode(`${c}.100`, darkPillBg)(props),
            color: mode(`${c}.800`, `${c}.100`)(props),
            boxShadow: mode('xs', 'none')(props),
        };
    },

    // ====================================================================
    // Faz 2 · Sinav statu (exam) ve SRS tonlu badge varyantlari.
    // ====================================================================
    correct: () => ({
      bg: 'exam.correct.bg',
      color: 'exam.correct.text',
      borderWidth: '1px',
      borderColor: 'exam.correct.border',
      borderRadius: 'md',
    }),
    incorrect: () => ({
      bg: 'exam.incorrect.bg',
      color: 'exam.incorrect.text',
      borderWidth: '1px',
      borderColor: 'exam.incorrect.border',
      borderRadius: 'md',
    }),
    review: () => ({
      bg: 'exam.review.bg',
      color: 'exam.review.text',
      borderWidth: '1px',
      borderColor: 'exam.review.border',
      borderRadius: 'md',
    }),
    skipped: () => ({
      bg: 'exam.skipped.bg',
      color: 'exam.skipped.text',
      borderWidth: '1px',
      borderColor: 'exam.skipped.border',
      borderRadius: 'md',
    }),
    partial: () => ({
      bg: 'exam.partial.bg',
      color: 'exam.partial.text',
      borderWidth: '1px',
      borderColor: 'exam.partial.border',
      borderRadius: 'md',
    }),
    // SRS rozetleri
    srsNew: () => ({
      bg: 'srs.new.bg',
      color: 'srs.new.text',
      borderWidth: '1px',
      borderColor: 'srs.new.border',
      borderRadius: 'full',
      px: 2.5,
    }),
    srsLearning: () => ({
      bg: 'srs.learning.bg',
      color: 'srs.learning.text',
      borderWidth: '1px',
      borderColor: 'srs.learning.border',
      borderRadius: 'full',
      px: 2.5,
    }),
    srsReview: () => ({
      bg: 'srs.review.bg',
      color: 'srs.review.text',
      borderWidth: '1px',
      borderColor: 'srs.review.border',
      borderRadius: 'full',
      px: 2.5,
    }),
    srsMastered: () => ({
      bg: 'srs.mastered.bg',
      color: 'srs.mastered.text',
      borderWidth: '1px',
      borderColor: 'srs.mastered.border',
      borderRadius: 'full',
      px: 2.5,
    }),
    // Premium / odul rozeti
    premium: () => ({
      bgGradient: 'linear(135deg, amber.300, amber.500)',
      color: 'amber.950',
      borderRadius: 'full',
      px: 2.5,
      fontWeight: 'bold',
      letterSpacing: 'micro',
      textTransform: 'uppercase',
    }),
  },
  defaultProps: {
    variant: 'subtle',
    colorScheme: 'gray',
  },
};

export default Badge;
